<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col-auto">
                Approval
            </div>
            <div class="col"></div>
            <div class="col-auto"><i (click)="close()" class="bi bi-x-lg cursor-pointer"></i></div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="col-md-12 approvalmatrix">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 p-0">
                        <div class="card">
                            <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                            <div class="card-body" *ngIf="isApprovalLavel">
                                <div id="content">
                                    <ul class="timeline">
                                        <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                            <div class="row align-items-center">
                                                <div class="col-2">
                                                    <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                        mat-card-image class="userImage"
                                                        [src]="common.PhotoLink(Tracking['Photo'])" />
                                                    <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                        class="initial-image">
                                                        <div class="image">
                                                            {{common.getInitial(Tracking['ApproverName'])}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <h3 class="m-0">
                                                        {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                    </h3>
                                                </div>
                                                <div class="col-auto"><span class="badge"
                                                        [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                </div>
                                            </div>
                                            <!-- <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div> -->
                                            <hr />
                                        </li>
                                        <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                            <div class="row align-items-center">
                                                <div class="col-2">
                                                    <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                        mat-card-image class="userImage"
                                                        [src]="common.PhotoLink(Tracking['Photo'])" />
                                                    <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                        class="initial-image">
                                                        <div class="image">
                                                            {{common.getInitial(Tracking['ApproverName'])}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                    </h3>
                                                </div>
                                                <div class="col-auto"><span class="badge"
                                                        [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                </div>
                                            </div>
                                            <label class="date">{{Tracking['ActionDate']}}</label>
                                            <p class="remark">{{Tracking['Remark']}}</p>
                                        </li>
                                        <li class="event p-0 m-0">
                                            <div class="row">
                                                <h3>Submitted on</h3>
                                            </div>
                                            <label class="date">{{RequestDate}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="close()" class="btn btn-primary btn-sm">
                    Close
                </button>
            </div>
        </div>
    </div> -->
</div>